export default __webpack_public_path__ + "static/media/landing-village-cut-min.45b1332a.svg";